import React from 'react';
import ReactECharts from 'echarts-for-react';

const PerformanceChart = ({ dateRange }) => {
  const getOption = () => {
    // Generate sample data based on date range
    const days = dateRange === '7d' ? 7 : dateRange === '30d' ? 30 : 90;
    const dates = [];
    const sentData = [];
    const openedData = [];
    const clickedData = [];

    for (let i = days - 1; i >= 0; i--) {
      const date = new Date();
      date.setDate(date.getDate() - i);
      dates.push(date.toISOString().split('T')[0]);
      
      // Generate sample data
      const sent = Math.floor(Math.random() * 100) + 50;
      const opened = Math.floor(sent * (0.15 + Math.random() * 0.15));
      const clicked = Math.floor(opened * (0.1 + Math.random() * 0.1));
      
      sentData.push(sent);
      openedData.push(opened);
      clickedData.push(clicked);
    }

    return {
      title: {
        text: 'Campaign Performance',
        textStyle: {
          fontSize: 16,
          fontWeight: 'bold'
        }
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross'
        }
      },
      legend: {
        data: ['Sent', 'Opened', 'Clicked'],
        bottom: 0
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '15%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        data: dates,
        axisLabel: {
          formatter: function (value) {
            return new Date(value).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
          }
        }
      },
      yAxis: {
        type: 'value'
      },
      series: [
        {
          name: 'Sent',
          type: 'line',
          data: sentData,
          smooth: true,
          lineStyle: {
            color: '#3B82F6'
          },
          itemStyle: {
            color: '#3B82F6'
          }
        },
        {
          name: 'Opened',
          type: 'line',
          data: openedData,
          smooth: true,
          lineStyle: {
            color: '#10B981'
          },
          itemStyle: {
            color: '#10B981'
          }
        },
        {
          name: 'Clicked',
          type: 'line',
          data: clickedData,
          smooth: true,
          lineStyle: {
            color: '#8B5CF6'
          },
          itemStyle: {
            color: '#8B5CF6'
          }
        }
      ]
    };
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
      <ReactECharts
        option={getOption()}
        style={{ height: '400px' }}
        opts={{ renderer: 'canvas' }}
      />
    </div>
  );
};

export default PerformanceChart;